import router from '@/router'
import { AppSidebar, AppHeader } from '@/components'
import FooterOutgoingLinks from '@/components/FooterOutgoingLinks.vue'

export const routes = [
  {
    path: '/integrations',
    name: 'integrations',
    components: {
      default: () => import('./integrations.vue'),
      sidebar: AppSidebar,
      header: AppHeader,
      footer: FooterOutgoingLinks
    },
    meta: {
      sitemap: {
        title: 'Connected data',
        description: 'Link accounting software and bank accounts',
        conditions: {
          any: [
            { fact: 'portal', path: '$.enableIllionIntegration', operator: 'equal', value: true },
            { fact: 'portal', path: '$.enableAccountingSoftwareIntegration', operator: 'equal', value: true },
            { fact: 'portal', path: '$.enableOpenBankingIntegration', operator: 'equal', value: true },
            { fact: 'portal', path: '$.enablePlaidIntegration', operator: 'equal', value: true }
          ]
        }
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    }
  }
]

export default () => {
  routes.forEach(route => router.addRoute(route))
}
